import React from "react";
import styled from "styled-components";
//
import { RichText } from "components/prismic";
//
export default ({ image, ...rest }) => (
  <Wrap>
    <img src={image.url} alt={image.alt} />
    <p>{image.alt}</p>
  </Wrap>
);
//
const Wrap = styled.div`
  padding-bottom: 0.5rem;
  img {
    // width: 100%;
  }

  p {
    padding: 0 0.2rem;
    margin: 0;
    font-style: italic;
  }
`;
